module.exports = __webpack_public_path__ + "media/images/DoorBottom-8eeecd5804f635b997cd2d935a1a778b.png";